// extracted by mini-css-extract-plugin
module.exports = {"formula":"Info_formula__2hxJE","hint":"Info_hint__2YepO","task":"Info_task__3XJMT","pulsate":"Info_pulsate__2c7Lw"};